import { FixableFlags } from '@/apis/family_application/requests'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

// Enrolled in SOEP and received another scholarship are not fixable by the user.
// Instead we'll run a check on USBE every once in a while to check if these flags are valid or not

export type FormEditState =
  | FixableFlags
  | 'form-edit-identity-verification'
  | 'form-edit-student-details'
  | 'form-edit-income-details'
  | "dashboard-edit-student-details"
  | 'none'

type State = {
  mode: FormEditState
}

const initialState: State = {
  mode: 'none',
}

const formMode = createSlice({
  name: 'formEdit',
  initialState,
  reducers: {
    setEditMode: (state, action: PayloadAction<FormEditState>) => {
      state.mode = action.payload
    },
  },
})

// Export actions
export const { setEditMode } = formMode.actions

// Export reducer
export default formMode.reducer

// Selector
export const selectMode = (state: RootState) => state.applicationStatus.mode
